import { SET_ACCOUNT_LIST } from "../ActionName/ActionName"

export const setAccountList = (data) => {
    return {
        type: SET_ACCOUNT_LIST,
        value: data
    }
}
